import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  messageAbsenceVisitId: {
    padding: 15,
    textAlign: 'center',
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
  expandedOrderList: {
    padding: '20px 15px',
  },
  orderInfoList: {
    margin: 0,
    padding: 0,
    color: theme.colors.light.lightCyan,
    fontSize: 12,
    listStyle: 'none',
  },
  refundHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  refundTitle: {
    fontSize: theme.fonts.sizes.font16PX,
    fontWeight: 700,
  },
  refundButtonWrapper: {
    marginRight: 15,
  },
  orderItemsList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const useStylesSmallPrimaryButton = makeStyles(theme => ({
  root: {
    height: 'auto',
    padding: '9px 26px',
    marginBottom: 0,
    lineHeight: '1',
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
    },
  },
}));

export const useStylesSmallPrimaryDisabledButton = makeStyles(theme => ({
  root: {
    height: 'auto',
    padding: '9px 26px',
    marginBottom: 0,
    lineHeight: '1',
    backgroundColor: theme.colors.dark.steelBlue,
    '&.Mui-disabled': {
      color: theme.colors.light.lightSteelBlue,
    },
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
    },
  },
}));
